import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds, teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={videos.chicago_sky.videoUrl}
    title="Watch Chicago Sky basketball"
    subtitle="Get live games, local team coverage & more. Regional restrictions apply."
    networkSet="womensBasketball"
    customNetworks={['marquee']}
    logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-chicago-sky.png?ch=width&auto=format,compress"
    logoHeight="100px"
    league="WNBA"
    showRSN={true}
    sportId={sportIds.Basketball}
    leagueId={leagueIds.WNBA}
    teamId={teamIds['Chicago Sky']}
  />
)
